import FileTypes from '@/config/file-types'
import { SIZE_OPTIONS } from '@pt/config/resolution'
import i18n from '@/lang'

export const allowAudioTypes = ['mp3', 'aac', 'wav']

export const allowImageTypes = ['png', 'jpeg', 'gif', 'jpg']

export const allowVideoTypes = ['mp4', 'avi', 'mkv', 'flv', 'mov', 'webm']

// 筛选项只支持mp4和mov(其他视频格式类型会在转码后转码mp4)
export const allowFilterVideoTypes = ['mp4', 'mov']

export const allowArchiveTypes = ['psd', 'zip']

export const allowPsdTypes = ['psd']

export const allowZipTypes = ['zip']

export const allowFontTypes = ['ttf', 'otf']

export const allowResourceTypes = [
  ...allowAudioTypes,
  ...allowImageTypes,
  ...allowVideoTypes,
  ...allowFontTypes,
  ...allowArchiveTypes,
]

export const allowMediaTypes = allowResourceTypes
  .map((key) => {
    const fileTypes: { [key: string]: any } = FileTypes
    if (fileTypes[key] && fileTypes[key].mediaTypes) {
      return fileTypes[key].mediaTypes
    }
    return []
  })
  .flat()

export const getTypesByExtension = (ext: string): string => {
  if (allowAudioTypes.includes(ext)) {
    return 'audio'
  } else if (allowImageTypes.includes(ext)) {
    return 'image'
  } else if (allowVideoTypes.includes(ext)) {
    return 'video'
  } else if (allowPsdTypes.includes(ext)) {
    return 'psd'
  } else if (allowZipTypes.includes(ext)) {
    return 'zip'
  } else if (allowFontTypes.includes(ext)) {
    return 'font'
  }
  return 'other'
}

export const creativeDataSource = [
  {
    label: i18n.t('resourceManager.filter.upload'),
    value: 1,
  },
  {
    label: i18n.t('resourceManager.filter.share'),
    value: 2,
  },
  {
    label: i18n.t('resourceManager.filter.synchronization'),
    value: 3,
  },
]

export const creativeDataType = [
  {
    label: i18n.t('resourceManager.filter.image'),
    value: 'image',
  },
  {
    label: i18n.t('resourceManager.filter.video'),
    value: 'video',
  },
  {
    label: i18n.t('resourceManager.filter.audio'),
    value: 'audio',
  },
  {
    label: i18n.t('resourceManager.filter.h5'),
    value: 'h5',
  },
  {
    label: i18n.t('resourceManager.filter.font'),
    value: 'font',
  },
  {
    label: i18n.t('resourceManager.filter.psd'),
    value: 'psd',
  },
  {
    label: i18n.t('resourceManager.filter.dragonbone'),
    value: 'dragonbone',
  },
  {
    label: i18n.t('resourceManager.filter.seqframe'),
    value: 'seqframe',
  },
  {
    label: i18n.t('resourceManager.filter.zip'),
    value: 'zip',
  },
  {
    label: i18n.t('resourceManager.filter.screenRecordFile'),
    value: 'vrecpkg',
  },
  {
    label: i18n.t('playTurbo.order.filter.3dmodel'),
    value: '3d_model',
  },
]

export const creativeDataFormat = [
  {
    label: i18n.t('resourceManager.filter.audio'),
    options: allowAudioTypes.map((key) => {
      return {
        label: key,
        value: key,
      }
    }),
  },
  {
    label: i18n.t('resourceManager.filter.image'),
    options: allowImageTypes.map((key) => {
      return {
        label: key,
        value: key,
      }
    }),
  },
  {
    label: i18n.t('resourceManager.filter.video'),
    options: allowFilterVideoTypes.map((key) => {
      return {
        label: key,
        value: key,
      }
    }),
  },
  {
    label: i18n.t('resourceManager.filter.font'),
    options: allowFontTypes.map((key) => {
      return {
        label: key,
        value: key,
      }
    }),
  },
  {
    label: i18n.t('resourceManager.filter.other'),
    options: allowArchiveTypes.map((key) => {
      return {
        label: key,
        value: key,
      }
    }),
  },
]

export const creativeDataDurationsUnit = [
  {
    label: i18n.t('resourceManager.filter.second'),
    value: 'sec',
  },
  {
    label: i18n.t('resourceManager.filter.minute'),
    value: 'min',
  },
  {
    label: i18n.t('resourceManager.filter.hour'),
    value: 'hour',
  },
]

export const creativeSizeUnit = [
  {
    label: 'KB',
    value: 'KB',
  },
  {
    label: 'MB',
    value: 'MB',
  },
]

export const creativeDataDirections = [
  {
    label: i18n.t('resourceManager.filter.horizontal'),
    value: 1,
  },
  {
    label: i18n.t('resourceManager.filter.vertical'),
    value: 2,
  },
  {
    label: i18n.t('resourceManager.filter.square'),
    value: 3,
  },
]

export const creativeDataRatios = [
  ...SIZE_OPTIONS.landscape,
  ...SIZE_OPTIONS.portrait,
]

export const utilsIcon: {
  [key: string]: string
} = {
  image: 'pic',
  audio: 'voice',
  video: 'video',
  font: 'word',
  vrecpkg: 'default_zip',
  zip: 'default_zip',
  h5: 'default_h5',
  psd: 'default_psd',
  seqframe: 'default_zip',
  dragonbone: 'default_zip',
}

export const nameRegExp = new RegExp('[:<>^/?\\\\"*|]')
